export default ({ request }) => ({
  changeOrdeDemandPackingListApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/list',
      method: 'post',
      data
    })
  },
  changeOrdeDemandPackingSaveApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/save',
      method: 'post',
      data
    })
  },
  changeOrdeDemandPackingDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/detail',
      method: 'post',
      data
    })
  },
  changeOrdeDemandPackingDelApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/del',
      method: 'post',
      data
    })
  },
  changeOrderDemandPackageGoodsListApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/goods/list',
      method: 'post',
      data,
    })
  },
  changeOrderDemandPackageGoodsBatchListApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/goods/batch/list',
      method: 'post',
      data,
    })
  },
  changeOrderDemandPackageGoodsDelApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/goods/del',
      method: 'post',
      data,
    })
  },
  changeOrderDemandPackageGoodsSaveApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/goods/save',
      method: 'post',
      data,
    })
  },
  changeOrderDemandPackageGoodsEditApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/packing/goods/edit',
      method: 'post',
      data,
    })
  },
})
